interface ToastProps {
  type: 'success' | 'error' | 'warning' | 'info' | 'danger';
  message: string;
  title?: string;
}
import toast from 'react-hot-toast';
export const Toast = ({ type, message, title }: ToastProps): void => {
  if (message !== '') {
    if (type === 'success') {
      toast.success(message, {
        duration: 5000,
        position: 'top-center',
      });
    }
    else if (type === 'error' || type === 'danger') {
      toast.error(message, {
        duration: 5000,
        position: 'top-center',
      });
    }
    else {
      toast.success(message, {
        duration: 5000,
        position: 'top-center',
      });
    }
  }
  // You can integrate with a toast library like react-toastify
  //console.log(`${type}: ${title || ''} - ${message}`);
  // Example: toast[type](message, { title });
};